import { useEffect, useMemo, useRef, useState } from 'react';

import isSet from '../../Helpers/isSet';
import { addJornayaScript, createJornayaInput, JORNAYA_INPUT_ID } from '../../Helpers/jornaya';
import styleStringToObj from '../../Helpers/styleStringToObj';
import insurancePickerData from '../../data/insurancePickerData';

import InputPersonalInsurancePicker from '../../Components/InputPersonalInsurancePicker';
import InputZipcode from '../../Components/InputZipcode';

import content from '../../../../../public/js/landing_page_personal_content.json';

const FormView = ({ useFormData, onSubmit }) => {
    const [formData, setFormData, showError] = useFormData();
    const { inputs } = content;

    useEffect(() => {
        sessionStorage.removeItem('formData');
    }, []);

    const inputFields = {
        zipcode: InputZipcode,
        personalInsurancePicker: InputPersonalInsurancePicker,
    };

    const preselectedPolicies = useMemo(() => {
        return insurancePickerData.filter(policy => {
            return window?.preselected_policies?.includes(policy.id);
        });
    }, []);

    useEffect(() => {
        setFormData({
            ...formData,
            insurance_types: preselectedPolicies,
        });
    }, [preselectedPolicies]);

    const handleInputChange = ({ name, element, isValid = true }) => {
        setFormData(prevData => {
            let thisInvalidList = prevData.invalidFields || [];
            if (!isValid) {
                if (!thisInvalidList.includes(name)) {
                    thisInvalidList.push(name);
                }
            } else {
                thisInvalidList = thisInvalidList.filter(invalid => invalid !== name);
            }
            const thisData = {
                ...prevData,
                [name]: element.value,
                invalidFields: thisInvalidList,
            };
            return thisData;
        });
    };

    useEffect(() => {
        // jornaya compliance script
        addJornayaScript();

        /* this element gets populated with the leadid token value, which we send to the create lead API */
        createJornayaInput('lead-form');

        setTimeout(() => {
            const leadIdToken = document.getElementById(JORNAYA_INPUT_ID)?.value;
            setFormData(prevData => ({
                ...prevData,
                jornaya_id: leadIdToken,
            }));
        }, 1000);
    }, []);

    return (
        <form id="lead-form">
            {inputs.map((input, index) => {
                const { type, requirementText, name, label, placeholder, required } = input;
                const inlineStyle = styleStringToObj(input.inlineStyle || '');
                const Component = inputFields[type];
                const errorText =
                    required && !isSet(formData[name])
                        ? requirementText
                            ? requirementText
                            : 'This field is required'
                        : '';
                return (
                    <Component
                        key={index}
                        requirementText={requirementText}
                        label={label}
                        type={type}
                        name={name}
                        isRequired={required}
                        value={
                            type === 'insurancePicker' && preselectedPolicies.length
                                ? preselectedPolicies
                                : formData[name] || ''
                        }
                        externalErrorMessage={errorText}
                        showError={showError}
                        placeholder={placeholder}
                        required={required}
                        inlineStyle={inlineStyle}
                        onChange={(e, valid) =>
                            handleInputChange({
                                type,
                                name,
                                element: e.target,
                                isValid: valid,
                            })
                        }
                    />
                );
            })}
            <button className="start-quote" type="submit" onClick={onSubmit}>
                GET STARTED
            </button>
        </form>
    );
};

const FormPersonal = ({ useFormData }) => {
    const [formData, setFormData, showErrorDefault] = useFormData();
    const [showError, setShowError] = useState(showErrorDefault);

    const requiredFields = useRef(content.inputs.filter(input => input.required).map(input => input.name) || []);

    const handleStartQuote = (e, doVerify = true) => {
        e.preventDefault();
        let ok = true;
        if (doVerify) {
            setShowError(false);
            const missingFields = requiredFields.current.filter(field => {
                const fieldValue = formData[field];
                return !isSet(fieldValue);
            });
            if (missingFields.length > 0 || formData.invalidFields?.length > 0) {
                ok = false;
                setTimeout(() => {
                    setShowError(true);
                }, 100);
                return;
            }
        }
        if (ok) {
            sessionStorage.setItem('formData', JSON.stringify(formData));
            window.location.href = '/my-quote?personal=true';
        }
    };

    return <FormView useFormData={() => [formData, setFormData, showError]} onSubmit={handleStartQuote} />;
};

export default FormPersonal;
